import { Link } from "react-router-dom";
import { ArrowUpRight, FileText } from "lucide-react";
import { ProjectVisual } from "./bits";

const CATEGORY_LABELS = {
  built: "Built by TNN Africa",
  partners: "Built with Partners",
  education: "Education Initiative",
};

export default function ProjectCard({ project }) {
  const footer = project.flagship ? (
    <span className="inline-flex items-center gap-1.5 text-xs font-bold text-tnn-purple">
      <FileText className="w-3.5 h-3.5" /> View Case Study
    </span>
  ) : project.url ? (
    <span className="inline-flex items-center gap-1.5 text-xs font-bold text-tnn-purple">
      Visit Website <ArrowUpRight className="w-3.5 h-3.5" />
    </span>
  ) : null;

  const inner = (
    <div className="flex flex-col h-full">
      <div className="border-b border-tnn-ink/6">
        <ProjectVisual project={project} />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <p className="text-[10px] font-bold tracking-[0.16em] uppercase text-tnn-purple/60">
          {CATEGORY_LABELS[project.category]}
        </p>
        <h3 className="mt-2 font-display text-lg font-semibold text-tnn-ink group-hover:text-tnn-purple transition-colors duration-200">
          {project.name}
        </h3>
        <p className="mt-1.5 text-sm text-tnn-muted leading-relaxed">{project.tagline}</p>
        <div className="mt-4 flex flex-wrap gap-1.5">
          {project.contribution.slice(0, 4).map((c) => (
            <span key={c} className="text-[10px] font-semibold px-2.5 py-1 rounded-full bg-tnn-soft text-tnn-purple">
              {c}
            </span>
          ))}
        </div>
        {footer && <div className="mt-auto pt-5">{footer}</div>}
      </div>
    </div>
  );
  const cls =
    "group block bg-white border border-tnn-ink/8 rounded-3xl overflow-hidden h-full transition-[box-shadow,transform] duration-300 hover:shadow-[0_20px_50px_rgba(40,0,40,0.10)] hover:-translate-y-1";
  if (project.flagship) {
    return (
      <Link to={`/our-work/${project.slug}`} data-testid={`project-card-${project.slug}`} className={cls}>
        {inner}
      </Link>
    );
  }
  if (project.url) {
    return (
      <a href={project.url} target="_blank" rel="noopener noreferrer" data-testid={`project-card-${project.slug}`} className={cls}>
        {inner}
      </a>
    );
  }
  return (
    <div data-testid={`project-card-${project.slug}`} className={cls}>
      {inner}
    </div>
  );
}
